'use client'

import { useState, useEffect } from 'react';
import ResultsRow from './results-row';
// Header row removed — new card design is self-explanatory
import Loading from '../utils/loading';
import EmptyRow from './empty-row';
import { getLeaderboard } from '../utils/supabaseData';
import { useSupabaseData } from '@/hooks/useSupabaseData';
import { sortBy } from 'lodash';
import FilterRow from './filter-row';
import './results-row.css';
import '../result-individual/result-individual.css';

const ResultsTable = ({ savedTournament, setPodium }) => {
  const [sortFilter, setSortFilter] = useState('totalpoints');
  const [sortOrder, setSortOrder] = useState('desc');

  const { data: results, loading } = useSupabaseData(
    () => getLeaderboard(savedTournament),
    [savedTournament]
  );

  useEffect(() => {
    if (results && results.length > 0) {
      setPodium(results);
    }
  }, [results, setPodium]);

  const generateResults = () => {
    if (!results || results.length === 0) return [<EmptyRow key="empty" />];

    const resultList = [];
    let animationIncrement = 0;
    let atleastOnePlayed = false;

    let resultsSorted = sortBy(results, (obj) => parseFloat(obj[sortFilter]));
    if (sortOrder !== 'asc') resultsSorted = resultsSorted.reverse();

    resultsSorted.forEach((result) => {
      // Skip top 3 — they're shown in the Podium component
      if (result.rank >= 1 && result.rank <= 3) return;

      if (result.totalmatch > 0) {
        atleastOnePlayed = true;
        const animationDelayValue = (0.3 + animationIncrement).toFixed(2);
        const uniqueURLKey = (!result.playerkey || result.playerkey === 'undefined' || result.playerkey.length === 0)
          ? result.rank + result.slackuid
          : result.playerkey;

        resultList.push(
          <ResultsRow
            name={result.name}
            played={result.totalmatch}
            won={result.matchpoints}
            loss={result.loss}
            totalPoints={result.totalpoints}
            bonus={result.bonuspoints}
            lastFive={result.last5}
            best={result.beststreak}
            id={uniqueURLKey}
            imageurl={result.imageurl}
            rank={result.rank}
            rankChange={result.rankChange}
            key={result.name}
            accuracy={result.accuracy}
            animationDelayValue={animationDelayValue}
          />,
        );
        animationIncrement += 0.1;
      }
    });

    if (!atleastOnePlayed) {
      resultList.push(<EmptyRow key="empty" />);
    }

    return resultList;
  };

  if (loading) {
    return (
      <div className="results-table">
        <Loading />
      </div>
    );
  }

  return (
    <div className="results-table">
      {/* FilterRow hidden until sort/order UX is redesigned */}
      {generateResults()}
    </div>
  );
};

export default ResultsTable;
